<template>
  <el-dialog title="商城订单" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px" v-if="formVisible">
    <div class="input-box">
      <el-input v-model="inputVal" placeholder="搜索订单号" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
    </div>
    <div class="cont-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订货订单" name="1"></el-tab-pane>
        <el-tab-pane label="积分订单" name="2"></el-tab-pane>
        <el-tab-pane label="秒杀订单" name="3"></el-tab-pane>
        <!-- <el-tab-pane label="换货订单" name="5"></el-tab-pane> -->
      </el-tabs>
    </div>
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="cont-box">
        <div class="list-box">
          <div class="list" v-for="(item,index) in orderOptions" :key="index">
            <div class="order-no">
              订单号 <span class="no">{{item.orderNum}}</span> <i class="el-icon-copy-document" style="cursor: pointer;" @click="handleCopy(item)"></i>
              <div class="icon-rig"><em>{{getOrderStaus(item.state)}}</em><span @click="handleActive(item)"><i :class="item.active?'el-icon-arrow-down':'el-icon-arrow-up'"></i></span></div>

            </div>
            <div class="order-info" v-if="!item.active">
              <div>
                <span>下单时间：</span>
                <p>{{item.createdTime}}</p>
              </div>
              <div>
                <span>发货时间：</span>
                <p>{{item.sendTime}}</p>
              </div>
              <div>
                <span>备注：</span>
                <p>{{item.orderRemark}}</p>
              </div>
              <div>
                <span>收货信息：</span>
                <p>{{item.name}} {{item.phone}}<br />{{item.addrProvince}}{{item.addrCity}}{{item.addrArea}}{{item.addrDetail}}</p>
              </div>
            </div>
            <div class="order-img">
              <div class="img-box">
                <div v-for="(itt,idx) in item.goods" :key="idx">
                  <img :src="itt.skuSpecImg" />
                  <p class="ellipsis1">{{itt.name}}</p>
                </div>
              </div>
              <div class="amount">￥{{item.goodsPayMoney}}<span><br />共{{item.goodsNum}}件</span></div>
            </div>
            <div class="send fr"><el-button type="primary" size="small" @click="handleSend(item)">发送</el-button></div>
          </div>
        </div>
      </div>
      <el-empty description="暂无数据" v-if="!orderOptions.length"></el-empty>
    </div>
  </el-dialog>
</template>

<script>
import customerOrderApi from '@/api/order/customerOrder'
import { Subtr } from '@/utils/index'
export default {
  props: ['currentUser'],
  data() {
    return {
      formVisible: false,
      activeName: '1',
      orderOptions: [],
      inputVal: '',

    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;
  },
  watch: {
    inputVal(newVal) {
      if (newVal === '') {
        this.getOrderList()
      }
    }
  },
  methods: {
    handleActive(item) {
      item.active = !item.active;
      this.$forceUpdate()
    },
    handleSend(item) {
      this.formVisible = false;
      let type = +this.activeName === 1 ? 2 : (+this.activeName === 2 ? 4 : 3)
      this.$emit('created', item, type)
    },
    handleClick() {
      this.getOrderList()
    },
    handleShow(type) {
      this.activeName = type === 2 ? '1' : type === 3 ? '3' : '2'
      this.getOrderList()
    },
    handleSearch() {
      this.getOrderList()
    },
    getOrderList() {
      let params = { isGetGoods: true, orderNum: this.inputVal, type: +this.activeName, customerId: this.currentUser.toUserInfoId }
      customerOrderApi.fetchForList(params).then(({ data }) => {
        data.forEach(item => {
          item.goodsNum = 0;
          item.goods && item.goods.forEach(it => {
            item.goodsNum = Subtr(item.goodsNum, -it.combineCount)
          })
        })
        this.orderOptions = data
        this.formVisible = true;
      })
    },
    handleCopy(item) {
      var input = document.createElement('input')
      input.value = item.orderNum;
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success("复制成功");
    },
    getOrderStaus(state) {
      let stateName = ''
      switch (state) {
        case -1:
          stateName = '已失效';
          break;
        case 0:
          stateName = '已取消';
          break;
        case 1:
          stateName = '待支付';
          break;
        case 2:
          stateName = '待发货';
          break;
        case 3:
          stateName = '已发货';
          break;
        case 4:
          stateName = '已完成';
          break;
      }
      return stateName
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.cont-box {
  padding: 10px 20px;
  .list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .list {
      width: 48%;
      border: 1px solid #f3f3f3;
      border-radius: 6px;
      margin-bottom: 20px;
      .order-no {
        background: #f3f3f3;
        padding: 14px 15px;
        border-radius: 6px 6px 0 0;
        position: relative;
        .no {
          color: #1596cd;
          padding-right: 25px;
          padding-left: 10px;
        }
        .icon-rig {
          display: inline-block;
          float: right;
          em {
            margin-right: 33px;
            font-style: normal;
          }
          span {
            width: 42px;
            height: 44px;
            line-height: 50px;
            display: inline-block;
            background: #dcdcdc;
            position: absolute;
            right: 0;
            top: 0;
            border-radius: 6px 6px 0 0;
            text-align: center;
            cursor: pointer;
            i {
              font-size: 20px;
            }
          }
        }
      }
      .order-info {
        padding: 0 15px;
        div {
          font-size: 14px;
          color: #999;
          padding: 9px 0;
          span {
            width: 70px;
            display: inline-block;
            text-align: justify;
            text-align-last: justify;
            text-justify: distribute-all-lines;
          }
          p {
            display: inline-block;
            margin: 0;
            vertical-align: top;
            width: calc(100% - 90px);
          }
        }
      }
      .order-img {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        .img-box {
          display: flex;
          overflow: hidden;
          overflow-x: auto;
          div {
            margin-right: 6px;
            img {
              width: 70px;
              height: 70px;
              border-radius: 10px;
            }
            p {
              width: 70px;
              margin: 0;
              font-size: 12px;
              color: #666;
              padding: 8px 0;
            }
          }
        }
        .amount {
          width: 85px;
          display: inline-block;
          font-size: 14px;
          color: #000f29;
          text-align: right;
          span {
            color: #999;
          }
        }
      }
      .send {
        padding: 10px 15px;
      }
    }
  }
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .el-button {
    margin: 0 10px;
  }
}
.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
.ipt-box:last-child {
  margin-bottom: 0;
}

.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>
